module.exports = __webpack_public_path__ + "static/media/burgular5.7cc6266c.jpg";